import { CountBadge, Icon } from '@restomarker/ui-kit';
import { Link, useRouterState } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { t } from '@/shared/i18n';

import { useUnreadAlerts } from './api/useAlertFeed';

export const ALERTS_PATH = '/kiosk/alerts';

export interface AlertsNavLinkProps {
  className: string | undefined;
  activeClassName: string | undefined;
  /** Иконка слева — в полосе киоска; в кабинете разделы без иконок. */
  iconClassName?: string | undefined;
  onNavigate?: () => void;
}

/**
 * Колокольчик со счётчиком непрочитанного — ссылка на ленту точки (T-047).
 *
 * Число — текстом рядом с подписью и в `aria-label`, не только цветом. Внутри приложения
 * поверх печати ничего не всплывает: о новом предупреждении говорит только это число
 * (решение владельца 5).
 */
export function AlertsNavLink({
  className,
  activeClassName,
  iconClassName,
  onNavigate,
}: AlertsNavLinkProps): ReactElement {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const unread = useUnreadAlerts();
  const active = pathname === ALERTS_PATH;
  const label = t('alerts.feed.nav');

  return (
    <Link
      to={ALERTS_PATH}
      className={active ? activeClassName : className}
      aria-current={active ? 'page' : undefined}
      aria-label={
        unread > 0
          ? t('alerts.feed.navUnread').replace('{count}', unread > 99 ? '99+' : String(unread))
          : label
      }
      onClick={onNavigate}
    >
      {iconClassName !== undefined ? (
        <Icon name="bell" size={24} className={iconClassName} />
      ) : null}
      {label}
      <CountBadge count={unread} />
    </Link>
  );
}
